import { h, Component } from "preact";
import actions from "../../../actions";
import { connectWithTranslations } from "../../../../common/helpers/translationsHelpers";
import IconFileICSLight from "../../../../common/components/icons/IconFilterICSLight";
import IconFileCSVLight from "../../../../common/components/icons/IconFileCSVLight";
import IconDownload from "../../../../common/components/icons/IconDownload";
import Dropdown from "../../../../common/components/Dropdown";
import { urlFactory, downloadCalendar } from "../../../helpers";
import { GTM_ID, GA4EVENT } from "../../../constants";

class DownloadFilter extends Component {
    constructor(props) {
        super(props);

        this.renderTitle = this.renderTitle.bind(this);
        this.renderOption = this.renderOption.bind(this);
        this.onOptionSelected = this.onOptionSelected.bind(this);
        this.getOptionGtm = this.getOptionGtm.bind(this);
        this.getOptionGa4 = this.getOptionGa4.bind(this);
    }

    onOptionSelected(option) {
        const { config, settings } = this.props;
        var url = urlFactory.getEventDatesICalendar(config, settings, "v1");
        downloadCalendar(url, option.format);
    }

    getOptionGtm(option) {
        const { config } = this.props;
        return config.tracking && option.gtmId;
    }

    getOptionGa4(option) {
        const { config } = this.props;
        return config.tracking && option.ga4Id;
    }
    renderTitle() {
        return (
            <span>
                <IconDownload />
            </span>
        );
    }

    renderOption(option) {
        return (
            <span class="fxs_txt_center fxs_col_100 fxs_dBlock">
                <span>{option.name} </span>
                {option.icon}
            </span>
        );
    }

    render({ containerClass = "", buttonType = "fxs_btn_table_filter", buttonSize = "fxs_btn_xsmall", config }) {
        const options = [
            {
                name: "ICS",
                format: "text/calendar",
                gtmId: GTM_ID.ICSDOWNLOAD,
                icon: <IconFileICSLight />,
            },
            {
                name: "CSV",
                format: "text/csv",
                gtmId: GTM_ID.CSVDOWNLOAD,
                icon: <IconFileCSVLight />,
            },
        ];
        return (
            <Dropdown
                values={options}
                renderTitle={this.renderTitle}
                renderOption={this.renderOption}
                onOptionSelected={this.onOptionSelected}
                getOptionGtmId={this.getOptionGtm}
                getOptionGa4Id={(key) => this.getOptionGa4}
                getGa4Name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                getButtonGtmId={() => {
                    config.tracking && GTM_ID.DOWNLOAD;
                }}
                getButtonGa4Id={() => {
                    config.tracking && GA4EVENT.ELEMENTS.DOWNLOAD;
                }}
                containerClass={containerClass}
                titleClass={`fxs_btn ${buttonType} ${buttonSize} fxs_btn_download`}
            />
        );
    }
}

export default connectWithTranslations("config,settings", actions)(DownloadFilter);
